// Small pure helpers for "See more" style truncation of long descriptions.
// Kept framework-free so the logic is unit-testable in isolation.

const ELLIPSIS = '…';

// True when `text` is longer than `limit` and therefore worth collapsing behind
// a "See more" toggle. Whitespace-only / short strings never truncate.
export function needsTruncation(text: string | null | undefined, limit: number): boolean {
  return !!text && text.trim().length > limit;
}

// Truncate `text` to at most `limit` characters, preferring to break on a word
// boundary so we never cut a word in half, and append an ellipsis. Trailing
// punctuation/whitespace before the ellipsis is trimmed for a clean "word…".
// Returns the original text unchanged when it is within `limit`.
export function truncateAtWord(text: string | null | undefined, limit: number): string {
  if (!text) return '';
  if (!needsTruncation(text, limit)) return text;

  const slice = text.slice(0, limit);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace > 0 ? slice.slice(0, lastSpace) : slice;

  return cut.replace(/[\s.,;:!?—–-]+$/, '') + ELLIPSIS;
}
